import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authHeader = this.auth.getAuthorizationHeader();
    if (
      !authHeader ||
      req.params.get('access_token') ||
      req.params.get('share_token') ||
      (req.body && req.body.token)
    ) {
      return next.handle(req);
    }
    const authReq = req.clone({
      headers: req.headers.set('authorization', authHeader)
    });
    return next.handle(authReq);
  }
}
